import { useSyncExternalStore } from 'react'
import type { TeamPerson } from './api'

/**
 * Things people said on the floor, kept for this browser session. A bubble disappears after a few
 * seconds; this is how someone who looked away still reads what was said. It lives outside React so
 * recording a line is not a state update, and it is never sent anywhere.
 */
export interface ChatLine {
  id: string
  userId: string
  name: string
  text: string
  at: number
}

let lines: ChatLine[] = []
const seen = new Set<string>()
const listeners = new Set<() => void>()

export function ingestSpeech(people: readonly TeamPerson[], meId: string): void {
  let changed = false
  for (const p of people) {
    if (!p.pos?.say || p.userId === meId) continue
    const id = `${p.userId}:${p.pos.sayAt}`
    if (seen.has(id)) continue
    seen.add(id)
    lines = [...lines, { id, userId: p.userId, name: p.displayName, text: p.pos.say, at: p.pos.sayAt }].slice(-40)
    changed = true
  }
  if (changed) listeners.forEach((l) => l())
}

/** A line you said yourself, so it shows in your own log. */
export function recordOwn(userId: string, name: string, text: string): void {
  const at = Date.now()
  const id = `${userId}:${at}`
  seen.add(id)
  lines = [...lines, { id, userId, name, text, at }].slice(-40)
  listeners.forEach((l) => l())
}

export function useChatLines(): ChatLine[] {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb)
      return () => listeners.delete(cb)
    },
    () => lines,
    () => lines,
  )
}
